import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
 retrieve_product_warehouse_details: { status: "idle" },
};

export const retrieve_product_warehouse_details_Slice = createSlice({
 name: "retrieve_product_warehouse_details",
 initialState,
 reducers: {
  success_retrieve_product_warehouse_details: (state, action) => {
   state.retrieve_product_warehouse_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_product_warehouse_details: (state, action) => {
   state.retrieve_product_warehouse_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_product_warehouse_details: (state) => {
   state.retrieve_product_warehouse_details = { status: app_consts.IDLE };
  },
  loading_retrieve_product_warehouse_details: (state) => {
   state.retrieve_product_warehouse_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_product_warehouse_details, fail_retrieve_product_warehouse_details, reset_retrieve_product_warehouse_details, loading_retrieve_product_warehouse_details } = retrieve_product_warehouse_details_Slice.actions;

export default retrieve_product_warehouse_details_Slice.reducer;